import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import action from "../../Redux Store/actions";
import { Box } from "@mui/material";
import classes from "./MobileSubMenu.module.css";
import Tabs from "@mui/joy/Tabs";
import TabList from "@mui/joy/TabList";
import Tab, { tabClasses } from "@mui/joy/Tab";
import ListItemIcon from "@mui/material/ListItemIcon";
import Event from "../Icons/Event";
import Project from "../Icons/Project";
import Sustenance from "../Icons/Sustenance";
import AllAllotments from "../Icons/AllAllotments";
import BenefitPlan from "../Icons/BenefitPlan";
import ChannelPartner from "../Icons/ChannelPartner";
import FastBooking from "../Icons/FastBooking";
import Leads from "../Icons/Leads";
import Payments from "../Icons/Payments";
import Settings from "../Icons/Settings";
import Token from "../Icons/Token";
import User from "../Icons/User";
import CallIcon from "../Icons/CallIcon";
import BackArrow from "../Icons/BackArrow";
import ArrowDropDownIcon from "../Icons/ArrowDropDownIcon";
import ArrowRightIcon from "../Icons/ArrowRightIcon";
import RocketIcon from "../Icons/RocketIcon";
import CPSelected from "../Icons/CPSelected";
import ProfileIcon from "../../Assets/Images/Common/ProfileIcon.svg";
import ArraowRightIcon from "../../Assets/Images/Common/RightArrow.svg";
import siteVisitSubMenu from "../../Assets/Images/TabSustenanceDetailIcons/SiteVisit.svg";
import activeSiteVisitSubMenu from "../../Assets/Images/TabSustenanceDetailIcons/activeSiteVisit.svg";
import LogoutIcon from "@mui/icons-material/Logout";

import {
  Link,
  useLocation,
  useNavigate,
  useParams,
  useResolvedPath,
  useSearchParams,
} from "react-router-dom";
import store from "../../Redux Store/store";
import { errorTost } from "../../Services/Toast";
import { logOut, signOut } from "../../Services/LoginService";
import actions from "../../Redux Store/actions";
import { canOpenCrm2 } from "../Crm2/ui/access";
export default function MobileSubMenu() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [index, setIndex] = useState(0);
  const [menuArray, setMenuArray] = useState([
    {
      icon: <BenefitPlan color={"#667085"} fill={"none"} />,
      activeIcon: <BenefitPlan color={"#FFFF"} fill={"#1570EF"} />,
      name: "Dashboard",
      tabName: "Dashboard",
      isVisible: true,
      path: "/home/Dashboard",
    },
    {
      icon: <Event color={"#667085"} fill={"none"} />,
      activeIcon: <Event color={"#FFFF"} fill={"#1570EF"} />,
      name: "Event",
      tabName: "Event",
      isVisible: true,
      path: "/home/Event",
    },
    {
      icon: <Project color={"#667085"} fill={"none"} />,
      activeIcon: <Project color={"#FFFF"} fill={"#1570EF"} />,
      name: "Project",
      tabName: "Project",
      isVisible: true,
      path: "/home/Projects",
    },
    {
      icon: <Sustenance color={"#667085"} fill={"none"} />,
      activeIcon: <Sustenance color={"#FFFF"} fill={"#1570EF"} />,
      name: "Sustenance",
      tabName: "sustenance",
      isVisible: true,
      path: "/home/Sustenance",
    },
    {
      icon: <Token color={"#667085"} fill={"none"} />,
      activeIcon: <Token color={"#FFFF"} fill={"#1570EF"} />,
      name: "Token",
      tabName: "Token",
      isVisible: true,
      path: "/home/Token",
    },
    {
      icon: <ChannelPartner color={"#667085"} fill={"none"} />,
      activeIcon: <CPSelected />,
      name: "Partners",
      tabName: "channelpartner",
      isVisible: true,
      path: "/home/ChannelPartner",
    },
    {
      icon: <Payments color={"#667085"} fill={"none"} />,
      activeIcon: <Payments color={"#FFFF"} fill={"#1570EF"} />,
      name: "Payments",
      tabName: "payments",
      isVisible: true,
      path: "/home/Payments",
    },
    {
      icon: <Leads color={"#667085"} fill={"none"} />,
      activeIcon: <Leads color={"#FFFF"} fill={"#1570EF"} />,
      name: "Leads",
      tabName: "Leads",
      isVisible: true,
      path: "/home/Leads",
    },
    {
      icon: <FastBooking color={"#667085"} fill={"none"} />,
      activeIcon: <FastBooking color={"#1570EF"} fill={"#1570EF"} />,
      name: "FastBooking",
      tabName: "fastbooking",
      isVisible: true,
      path: "/home/FastBooking",
    },
    {
      icon: <BenefitPlan color={"#667085"} fill={"none"} />,
      activeIcon: <BenefitPlan color={"#FFFF"} fill={"#1570EF"} />,
      name: "Benefit Plan",
      tabName: "benefitplan",
      isVisible: true,
      path: "/home/BenefitPlan",
    },
    {
      icon: <CallIcon color={"#667085"} fill={"none"} />,
      activeIcon: <CallIcon color={"#FFFF"} fill={"#1570EF"} />,
      name: "CpSourcing",
      tabName: "CpSourcing",
      isVisible: true,
      path: "/home/cpSourcing",
    },
    {
      icon: <img src={siteVisitSubMenu} alt="Site Visit Approval" />,
      activeIcon: <img src={activeSiteVisitSubMenu} alt="Site Visit Approval" />,
      // `name` must match the accessibleTabs permission key; `label` is the display text.
      name: "Site Visit",
      label: "Site Visit Approval",
      tabName: "sitevisit",
      isVisible: true,
      path: "/home/SiteVisit",
    },
    {
      icon: <AllAllotments color={"#667085"} />,
      activeIcon: <AllAllotments color={"#1570EF"} />,
      name: "All Allotments",
      tabName: "AllAllotments",
      isVisible: true,
      path: "/home/AllAllotments",
    },
    // CRM2 M1.4b (DC-01): CRM 2.0 menu, shown when the role has the "CRM 2.0" key
    {
      icon: <AllAllotments color={"#667085"} />,
      activeIcon: <AllAllotments color={"#1570EF"} />,
      name: "CRM 2.0",
      tabName: "Crm2",
      isVisible: true,
      path: "/home/Crm2",
    },
    {
      icon: <User color={"#667085"} fill={"none"} />,
      activeIcon: <User color={"#FFFF"} fill={"#1570EF"} />,
      name: "Users",
      tabName: "users",
      isVisible: true,
      path: "/home/users",
    },
    {
      icon: <User color={"#667085"} fill={"none"} />,
      activeIcon: <User color={"#FFFF"} fill={"#1570EF"} />,
      name: "Sales Manager Persona",
      tabName: "SalesManagerPersona",
      isVisible: true,
      path: "/home/salesManagerPersona",
    },
    {
      icon: <Settings color={"#667085"} />,
      activeIcon: <Settings color={"#1570EF"} />,
      name: "Settings",
      tabName: "Settings",
      isVisible: true,
      path: "/home/Settings",
    },
    {
      icon: <Leads color={"#667085"} fill={"none"} />,
      activeIcon: <Leads color={"#FFFF"} fill={"#1570EF"} />,
      name: "Queue",
      tabName: "Queue",
      isVisible: true,
      path: "/home/Queue",
    },
    {
      icon: <FastBooking color={"#667085"} fill={"none"} />,
      activeIcon: <FastBooking color={"#1570EF"} fill={"#1570EF"} />,
      name: "Live Inventory",
      tabName: "liveInventory",
      isVisible: true,
      path: "/home/LiveInventory",
    },
    {
      // CRM 2.0 · M12 Template Builder (same as the desktop side menu)
      icon: <Project color={"#667085"} fill={"none"} />,
      activeIcon: <Project color={"#FFFF"} fill={"#1570EF"} />,
      name: "Templates",
      tabName: "templates",
      isVisible: true,
      path: "/home/Templates",
    },
    {
      // CRM 2.0 › Verify agreements (M12-F4): the VJ Signatory's QR scanner; needs the access path below
      icon: <Project color={"#667085"} fill={"none"} />,
      activeIcon: <Project color={"#FFFF"} fill={"#1570EF"} />,
      name: "CRM 2.0",
      label: "Agreement Sign",
      tabName: "verifyagreements",
      isVisible: true,
      path: "/crm2/verify-agreements",
      access: ["CRM 2.0", "Verify agreements"],
    },
  ]);

  let loggedInUser = {};
  loggedInUser = useSelector((state) => state.Auth.user);
  const activeMenu = useSelector((state) => state.ActiveMenu.activeMenu);

  useEffect(() => {
    dispatch(action.activeMenu("mobileSubMenu"));
  }, []);
  useEffect(() => {
    let tempSideMenuArray = [];
    menuArray.forEach((el, index) => {
      // null accessibleTabs (role saved without tabs) = no menu items
      // an item with `access` (Agreement Sign: CRM 2.0 › Verify agreements) needs every key on that path switched on
      // (level 1 sees all); CRM2 M1.4b: the CRM 2.0 item itself also needs CRM 2.0 › Tabs and sub-tabs (canOpenCrm2)
      const switchedOn = !el.access || loggedInUser?.roleId?.level == 1
        || el.access.reduce((node, key) => (node?.[key]?.isAccessible ? node[key] : null), loggedInUser?.roleId?.accessibleTabs || {});
      if (Object.keys(loggedInUser?.roleId?.accessibleTabs || {}).includes(el.name) && switchedOn && (el.name !== "CRM 2.0" || el.access || canOpenCrm2(loggedInUser))) {
        // console.log(el.name)
        // console.log('includes');
        tempSideMenuArray.push(el);
      }
    });
    setMenuArray([...tempSideMenuArray]);
    if (tempSideMenuArray.length > 0) {
      let menu = {
        tabName: tempSideMenuArray[0].tabName,
        name: tempSideMenuArray[0].name,
        path: tempSideMenuArray[0].path,
      };
      console.log(activeMenu);
      if (activeMenu === tempSideMenuArray[0].name) {
        navigate(tempSideMenuArray[0].path);
      }
    }
  }, []);
  // function logoutUser() {
  //   signOut()
  //     .then(({ err }) => {
  //       if (err) {
  //         errorTost(err);
  //       } else {
  //         store.dispatch(action.authLogout());
  //         sessionStorage.clear();
  //         localStorage.clear();
  //         navigate("/");
  //       }
  //     })
  //     .catch((error) => {
  //       errorTost(error);
  //     });
  // }
  async function logoutUser() {
    await store.dispatch(actions.authLogout());
    logOut()
      .then(({ err }) => {
        if (err) {
          errorTost(err);
        } else {

          localStorage.removeItem("supabase.auth.token");
          localStorage.removeItem("user");
          localStorage.removeItem("teamIds");
          // navigate("/");
        }
      })
      .catch((error) => {
        errorTost(error);
      }).finally(() => {
        store.dispatch(actions.authLogout());
        navigate("/");
      });
  }
  return (
    <Box className={classes.wrapperPage}>
      <Box className={classes.wrapperBlock}>
        <Tabs
          sx={{
            width: "100%",
            height: "100%",
            justifyContent: "space-between",
            display: "flex",
            fontSize: "2rem",
          }}
          size="lg"
          aria-label="Bottom Navigation"
          value={index}
          onChange={(event, value) => setIndex(value)}
        >
          <TabList
            variant="plain"
            sx={{
              padding: "0",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              gap: '2rem'
            }}
          >
            {menuArray.map(
              (menu, index) =>
                (menu.name !== "Event" &&
                  menu.name !== "Project" &&
                  menu.name !== "Leads" &&
                  menu.name !== 'Dashboard') && (
                  <Tab
                    // orientation="vertical"
                    sx={{
                      color:
                        activeMenu === menu.tabName.toLowerCase()
                          ? "#28303F"
                          : "#98A2B3",
                      "&:hover": {
                        color: "#98A2B3",
                      },
                      justifyContent: "space-between",
                    }}
                    className={classes.mobile_menu}
                    onClick={(e) => {
                      navigate(menu.path);
                    }}
                  >
                    <div
                      style={{ display: "flex", width: "100%", justifyContent: "space-between" }}
                      onClick={() => { navigate(menu.path); }}
                    >
                      <span style={{
                        display: 'flex',
                        alignItems: 'center'
                      }}>
                        <ListItemIcon className={classes.icon}>
                          {activeMenu === menu.tabName.toLowerCase()
                            ? menu.activeIcon
                            : menu.icon}
                        </ListItemIcon>
                        {menu.label || menu.name}
                      </span>

                      <img src={ArraowRightIcon} alt={"right arrow"} />
                    </div>
                  </Tab>
                )
            )}
          </TabList>
        </Tabs>
      </Box>
      <Box className={classes.wrapperBlock} style={{ display: 'flex', flexDirection: 'column', color: '#667085' }}>
        <div className={classes.wrapperLoggout}>{loggedInUser?.name}</div>
        <div className={classes.wrapperLoggout}>{loggedInUser?.email}</div>
      </Box>
      <Box className={classes.wrapperBlock}>
        <div className={classes.wrapperLoggout}>Logout
          <LogoutIcon
            className={classes.logoutIcon}
            onClick={logoutUser}
          />
        </div>
      </Box>
    </Box>
  );
}
